import logo from '../logo.svg';
import hostages from '../res/134.svg';
import logoNight from '../logo_night.svg';
import '../App.css';
import { useTranslation } from 'react-i18next';
import { React, useContext } from 'react';
import {useCurrentUser} from "../helpers/UserContext";
import {ConfigContext} from "../helpers/ConfigContext";
import {useConfig} from "../helpers/useConfig";
import TempGraph from './TempGraph';
import LatestDailyTempGraph from './LatestDailyTempGraph';
import LatestDailyRain from './LatestDailyRain';
import Now from './Now';

function AppNow({json, cssClasses, activities_json}) {
  
  const { t, i18n } = useTranslation();
  const { currentUser, fetchCurrentUser } = useCurrentUser();
  const {configData, setConfig} = useConfig();

  function isNight() {
    return cssClasses.includes("night");   
    
  } 
  var logoToDisplay = isNight() ? logoNight : logo; 
  var langcode = configData.lang;
  if (json.length === 0){ 
    return <div>loading AppNow...</div>
  }
  

  const nextDays = json.jws.forecastDays;
  const nextHours = json.jws.forecastHours;
  const ads = json.jws.Ads;
  const current = json.jws.current;
  const today = json.jws.today;
  const feelslike = json.jws.feelslike;
  const messages = json.jws.Messages;
  const statuses = json.jws.states.sigweather;
  const states = json.jws.states;
  const yest = json.jws.yest;
  const windstatus = json.jws.windstatus;
  const picoftheday = json.jws.LatestPicOfTheDay;
  const userpics = json.jws.LatestUserPic;
  const currentrecommendations = json.jws.current.recommendations;
    return (
      <>
    
    <div className={"clouds container-fluid App " + cssClasses}>
      
    <header
             className={"App-header row mb-2 " + (langcode === 1 ? "rtl" : "")}
           >
             <div className="row ">
               <div className="col-12 ">
                 <div className="AppHeader">
                   <div className="App-logo-container"><a href={`/`}><img src={logoToDisplay} className="App-logo" alt="logo"/></a></div>
                    {t("SLOGAN")}{" "}
                   - {t("WEBSITE_TITLE")}<div className="App-date"> {eval(`current.date${langcode}`)} </div>
   
                 </div>
               </div>
             </div>
           </header>
      <div className={"row " + (langcode === 1 ? "rtl" : "")}>
        <div className="col-xs-12 col-lg-12 ">
            <Now current={current} seasonTillNow={json.jws.seasonTillNow} today={today} cssClasses={cssClasses}  activities_json={activities_json} />
        </div>
      </div>
      <div className="graph col-xs-12 col-lg-12 ">
        <TempGraph
          className={cssClasses}
          lang={configData.lang}
          limit={3000}
          params={"temp2,temp1,HeatIdx,Dew"}
        />
      </div>
      <div className="graph col-xs-12 col-lg-12 ">
        <TempGraph
          className={cssClasses}
          lang={configData.lang}
          limit={2200}
          params={"temp1, windchill"}
        />
      </div>
      <div className="graph col-xs-12 col-lg-12 ">
        <TempGraph
          className={cssClasses}
          lang={configData.lang}
          limit={1800}
          params={"temp2,temp3"}
        />
      </div>
  
      
      <div className="graph col-xs-12 col-lg-12 ">
        
      </div>
      <div className="graph col-xs-12 col-lg-12 ">
        
      </div>
     </div>
     </>
    );
  
}

export default AppNow;
